var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinn2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 67,
    viewBox: "0 0 57 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.6821,
    cy: 63.6117,
    rx: 14.1497,
    ry: 2.72594,
    fill: "#7462E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6404 51.9801C36.7557 51.8022 36.9252 51.666 37.1222 51.5873C45.1714 48.3731 50.8482 40.6006 50.8482 31.5228C50.8482 19.5695 41.0054 9.87939 28.8638 9.87939C16.7221 9.87939 6.87939 19.5695 6.87939 31.5228C6.87939 40.6001 12.5555 48.3722 20.604 51.5868C20.8009 51.6654 20.9704 51.8016 21.0857 51.9796L27.1847 61.3948C27.9729 62.6117 29.7536 62.6117 30.5418 61.3948L36.6404 51.9801Z",
    fill: "#CEC5EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.926712 30.8106C0.926712 26.9462 4.05943 23.8135 7.92384 23.8135V23.8135C9.4696 23.8135 10.7227 25.0666 10.7227 26.6123V39.551C10.7227 41.0968 9.4696 42.3499 7.92384 42.3499V42.3499C4.05943 42.3499 0.926712 39.2172 0.926712 35.3528V30.8106Z",
    fill: "url(#paint0_linear_3045_5227)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6822 0.914551C13.3534 0.914551 0.926941 13.341 0.926941 28.6698V32.5353H4.38843V32.5358H52.9759V32.5353H56.4375V28.6698C56.4375 13.341 44.011 0.914551 28.6822 0.914551ZM52.9759 32.5353V28.9371C52.9759 15.52 42.0992 4.64335 28.6822 4.64335C15.2651 4.64335 4.38843 15.52 4.38843 28.9371V32.5353H52.9759Z",
    fill: "url(#paint1_linear_3045_5227)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6414 26.6123C46.6414 25.0666 47.8945 23.8135 49.4403 23.8135V23.8135C53.3047 23.8135 56.4374 26.9462 56.4374 30.8106V35.3528C56.4374 39.2172 53.3047 42.3499 49.4403 42.3499V42.3499C47.8945 42.3499 46.6414 41.0968 46.6414 39.551V26.6123Z",
    fill: "url(#paint2_linear_3045_5227)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.69 36.7689V28.1729H19.062C21.0151 28.1729 22.1371 29.378 22.1371 31.0699C22.1371 32.7855 20.9973 33.9669 19.0145 33.9669H17.471V36.7689H15.69ZM17.471 32.5303H18.7295C19.7862 32.5303 20.3027 31.9366 20.2968 31.0699C20.3027 30.215 19.7862 29.6392 18.7295 29.6332H17.471V32.5303Z",
    fill: "#232224"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8587 36.8758C23.3006 36.8758 22.8495 36.4306 22.8613 35.8785C22.8495 35.3323 23.3006 34.8871 23.8587 34.893C24.387 34.8871 24.8441 35.3323 24.8441 35.8785C24.8441 36.4306 24.387 36.8758 23.8587 36.8758Z",
    fill: "#232224"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2927 36.7689V28.1729H29.6646C31.6177 28.1729 32.7397 29.378 32.7397 31.0699C32.7397 32.7855 31.5999 33.9669 29.6171 33.9669H28.0736V36.7689H26.2927ZM28.0736 32.5303H29.3322C30.3889 32.5303 30.9053 31.9366 30.8994 31.0699C30.9053 30.215 30.3889 29.6392 29.3322 29.6332H28.0736V32.5303Z",
    fill: "#232224"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5893 28.1729V36.7689H33.832V28.1729H35.5893Z",
    fill: "#232224"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8754 36.8995C37.8986 36.8936 36.6875 35.6173 36.6934 33.5751C36.6875 31.5864 37.9164 30.2388 39.8042 30.2388C41.4961 30.2388 42.8318 31.3073 42.8318 33.5039V34.0025H38.4269C38.4269 34.9761 39.0028 35.5757 39.911 35.5816C40.5106 35.5757 40.9381 35.3145 41.1102 34.9286H42.7843C42.535 36.1219 41.4664 36.8936 39.8754 36.8995ZM38.4269 32.8983H41.1696C41.1637 32.1147 40.6234 31.5507 39.8398 31.5567C39.0324 31.5507 38.4625 32.1563 38.4269 32.8983Z",
    fill: "#232224"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3045_5227",
    x1: 1.74304,
    y1: 26.7098,
    x2: 11.3415,
    y2: 28.0206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C290EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9782F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3045_5227",
    x1: 5.55282,
    y1: 5.85539,
    x2: 51.5022,
    y2: 26.7003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C290EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9782F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3045_5227",
    x1: 47.4577,
    y1: 26.7098,
    x2: 53.5633,
    y2: 25.2566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C290EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9782F4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinn2);
export default __webpack_public_path__ + "static/media/spinn_2.5582ce0b9ca97530d97a782d045bbcee.svg";
export { ForwardRef as ReactComponent };